module.exports = __webpack_public_path__ + "img/021.2fd69ce9.png";